"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var functions_1 = require("./functions");
var defaultValue_1 = require("../JSchema/defaultValue");
var validFunction_1 = require("../JSchema/validFunction");
var calcFunction_1 = require("../JSchema/calcFunction");
var aggregateFunction_1 = require("../JSchema/aggregateFunction");
var clearData_1 = require("../JSchema/clearData");
var getValidations_1 = require("../JSchema/getValidations");
var WrappedPropertyBase = /** @class */ (function () {
    function WrappedPropertyBase(dest, parent, propName, schema, options) {
        var _this = this;
        this.$parent = dest;
        this.$key = propName;
        this._options = options;
        var internal = (this._internal = {
            vm: null,
            options: options,
            parent: parent,
            schema: schema,
            computed: {},
            watch: {},
            calcargs: [],
            reactiveData: undefined,
            needsCalcArgs: false,
            useComputedModel: false,
            vmUserData: null,
            mparent: null
        });
        var self = this;
        // root
        if (dest) {
            this.$root = dest.$root;
        }
        else {
            this.$root = this;
        }
        // create schema
        var $schema = (this.$schema = {
            type: schema.type
        });
        functions_1.wrapSchemaProps(this.$schema, internal, 'string', ['title', 'description']);
        if (schema.format) {
            $schema.format = schema.format;
        }
        // default value
        if (parent[propName] === undefined) {
            options.Vue.set(parent, propName, defaultValue_1.default(schema, true));
        }
        // wrap schema.emun
        if (schema.enum !== undefined) {
            if (self.$isArrayItem) {
                if (!Array.isArray(schema.enum)) {
                    functions_1.wrapSchemaProp(this.$schema, 'enum', internal, function (newValue) {
                        if (newValue) {
                            if (newValue.indexOf(self.$model) === -1) {
                                options.Vue.nextTick(function () {
                                    self.$removeRow();
                                });
                            }
                            /*
                            setTimeout(() => {
                              self.$removeRow();
                            });
                            */
                        }
                    });
                }
                else {
                    this.$schema.enum = schema.enum;
                    if (this.$schema.enum.indexOf(self.$model) === -1) {
                        options.Vue.nextTick(function () {
                            self.$removeRow();
                        });
                        /*
                        setTimeout(() => {
                          self.$removeRow();
                        }, 0);
                        */
                    }
                }
            }
            else {
                if (!Array.isArray(schema.enum)) {
                    functions_1.wrapSchemaProp(this.$schema, 'enum', internal);
                }
                else {
                    this.$schema.enum = schema.enum;
                }
            }
        }
        // wrap schema.required
        if (schema.required !== undefined &&
            schema.type !== 'object' &&
            (typeof schema.required === 'string' || typeof schema.required === 'boolean')) {
            schema.fieldRequired = schema.required;
        }
        functions_1.wrapSchemaProps(this.$schema, internal, 'boolean', ['fieldRequired']);
        // wrap schema.disabled
        if (internal.schema.disabled !== undefined) {
            if (typeof internal.schema.disabled !== 'boolean') {
                var prevDirty_1 = false;
                functions_1.wrapSchemaProp(this.$schema, 'disabled', internal, function (newValue, oldValue) {
                    if (newValue) {
                        prevDirty_1 = _this.$dirty; // zapamiętanie czy pole było odwiedzane
                        if (prevDirty_1) {
                            _this.$dirty = false;
                        }
                        var defValue = void 0;
                        if (schema.type === 'array') {
                            // zeby pominąc length
                            // debugger;
                            if (schema.default) {
                                defValue = Array.from(schema.default);
                            }
                            else {
                                defValue = [];
                            }
                        }
                        else {
                            // defValue = defaultValue(schema, false);
                            defValue = defaultValue_1.default(schema, true);
                        }
                        if (defValue === undefined) {
                            // gdy nie ma domyslnej wartości usuń z modelu === undefined
                            // options.Vue.delete(parent, propName);
                            // jednak lepiej nie usuwać, bo traci się wszystkie połczenia dynamiczne z Vue
                            // this.$setData(undefined);
                            parent[propName] = undefined;
                        }
                        else {
                            // ustaw domyślną wartość
                            _this.$setData(defValue, undefined, true);
                        }
                        // zapamietanie w $root któ®e są wyłączone
                        options.disabledFields[_this.$path] = true;
                    }
                    else {
                        if (prevDirty_1) {
                            _this.$dirty = prevDirty_1; // przywrócenie informacji że pole było odwiedzone
                        }
                        // console.log('restore disabled', parent[propName]), defaultValue(schema, true);
                        if (parent[propName] === undefined) {
                            // w przypadku gdy w polu jest indefined to ustawić domyslną wartośc
                            options.Vue.set(parent, propName, defaultValue_1.default(schema, true));
                            _this._internal.mparent = parent[propName];
                        }
                        // jeśli ustawione length to wymusić
                        if (schema.type === 'array' && $schema.length !== undefined) {
                            _this.$setLength($schema.length);
                        }
                        delete options.disabledFields[_this.$path];
                    }
                });
            }
            else {
                this.$schema.disabled = internal.schema.disabled;
                if (internal.schema.disabled) {
                    var defValue = defaultValue_1.default(schema, false);
                    if (defValue === undefined) {
                        options.Vue.delete(parent, propName);
                    }
                    else {
                        this.$setData(defValue);
                    }
                }
            }
        }
        /*
        if (schema.fieldRequired !== undefined) {
          if (typeof schema.fieldRequired !== 'boolean') {
            wrapSchemaProp(this, 'fieldRequired', internal, 'boolean');
          } else {
            this.$schema.fieldRequired = schema.fieldRequired;
          }
        }
        */
        // tworzenie funkcji validującej
        if (!options.disableValidations && schema.validFunc) {
            internal.needsCalcArgs = true;
            var validFunc_1 = validFunction_1.default(schema, schema.validFunc, true, process.env.NODE_ENV === 'development' && schema.debug);
            internal.computed.validFunc = {
                get: function () {
                    var funcvalue = validFunc_1.apply(parent, internal.calcargs);
                    if (funcvalue === true || funcvalue === undefined) {
                        return null;
                    }
                    if (funcvalue === false) {
                        return 'validFunc';
                    }
                    return funcvalue;
                }
            };
            /*
            internal.watch.validFunc = {
              handler: (newValue: any, oldValue: any) => {
                if (self.$dirty) {
                  self.$validate();
                }
              },
              immediate: false
            };
            */
        }
        // warning
        if (schema.warnings) {
            this.$schema.warnings = {};
            functions_1.wrapWarningProps(this.$schema, internal, 'boolean', ['fieldRequired']);
            if (!options.disableValidations && schema.warnings.validFunc) {
                internal.needsCalcArgs = true;
                var validFunc_2 = validFunction_1.default(schema, schema.warnings.validFunc, true, process.env.NODE_ENV === 'development' && schema.debug);
                internal.computed.warningValidFunc = {
                    get: function () {
                        var funcvalue = validFunc_2.apply(parent, internal.calcargs);
                        if (funcvalue === true || funcvalue === undefined) {
                            return null;
                        }
                        if (funcvalue === false) {
                            return 'validFunc';
                        }
                        return funcvalue;
                    }
                };
                /*
                internal.watch.validFunc = {
                  handler: (newValue: any, oldValue: any) => {
                    if (self.$dirty) {
                      self.$validate();
                    }
                  },
                  immediate: false
                };
                */
            }
        }
        if (!self._options.disableCalculations) {
            // tworzenie funkcji wyliczjącej wartośc na podstawie innych pól
            if (schema.calc) {
                internal.needsCalcArgs = true;
                var calcFunc_1 = calcFunction_1.default(schema, true, process.env.NODE_ENV === 'development' && schema.debug);
                internal.computed.calc = {
                    get: function () {
                        if (self.$disabled) {
                            return undefined;
                        }
                        if (process.env.NODE_ENV === 'development') {
                            try {
                                var res = calcFunc_1.apply(parent, internal.calcargs);
                                if ((res === undefined &&
                                    schema.calc.when === undefined &&
                                    schema.calc.indexOf('undefined') === -1) ||
                                    // tslint:disable-next-line: use-isnan
                                    res === NaN) {
                                    console.error('[DEBUG] ERR calc result: ', self.$path, schema.calc, res);
                                }
                                return res;
                            }
                            catch (err) {
                                console.error('[DEBUG] ERR calc: ', self.$path, schema.calc, err);
                                // tslint:disable-next-line: no-debugger
                                debugger;
                                return undefined;
                            }
                        }
                        else {
                            try {
                                return calcFunc_1.apply(parent, internal.calcargs);
                            }
                            catch (_a) {
                                return undefined;
                            }
                        }
                        // if (schema.calc ==='this.Dotacja + this.SrodkiWlasne + this.WkladOsobowy + this.WkladRzeczowy + 5')
                    }
                };
                internal.watch.calc = {
                    handler: function (newValue, oldValue) {
                        if (newValue !== undefined) {
                            if (!self.$dirty && (self._options.dirtyOnBlur || self._options.dirtyOnInput)) {
                                self.$dirty = true;
                            }
                            self.$setData(newValue, undefined, true);
                        }
                    },
                    immediate: true
                };
                // computed.calc = calcFunc;
            }
            // tworzenie funkcji sumującej wartość z tablicy
            if (schema.summary) {
                schema.aggregate = {
                    func: 'sum',
                    array: schema.summary.array,
                    property: schema.summary.property,
                    when: schema.summary.when,
                    if: schema.summary.if,
                    delay: schema.summary.delay
                };
                delete schema.summary;
            }
            // tworzenie funkcji sumującej wartość z tablicy
            if (schema.aggregate) {
                internal.needsCalcArgs = true;
                var aggregateFunc_1 = aggregateFunction_1.default(schema, true, process.env.NODE_ENV === 'development' && schema.debug);
                // if (schema.aggregate.async) {
                if (schema.aggregate.delay) {
                    // if (false) {
                    setTimeout(function () {
                        // console.log('delayed create aggregate',obj.$path);
                        var asyncVm = new internal.options.Vue({
                            computed: {
                                aggregate: {
                                    get: function () {
                                        // console.log('delayed run aggregate', obj.$path);
                                        if (process.env.NODE_ENV === 'development') {
                                            var res = aggregateFunc_1.apply(parent, internal.calcargs);
                                            // tslint:disable-next-line: use-isnan
                                            if (res === undefined || res === NaN) {
                                                console.error('ERR aggregate:delay result=', res, propName, schema.calc);
                                            }
                                            return res;
                                        }
                                        else {
                                            return aggregateFunc_1.apply(parent, internal.calcargs);
                                        }
                                    }
                                }
                            },
                            watch: {
                                aggregate: function (newValue) {
                                    internal.options.Vue.set(parent, propName, newValue);
                                }
                            }
                        });
                        //  this.vueInstances.push(asyncVm);
                    }, schema.aggregate.delay);
                }
                else {
                    internal.computed.aggregate = {
                        get: function () {
                            if (self.$disabled) {
                                return undefined;
                            }
                            // console.log('run agg', self.internal);
                            if (process.env.NODE_ENV === 'development') {
                                try {
                                    var res = aggregateFunc_1.apply(parent, internal.calcargs);
                                    // tslint:disable-next-line: use-isnan
                                    if (res === undefined || res === NaN) {
                                        console.error('[DEBUG] ERR aggregate result: ', self.$path, schema.aggregate, res);
                                    }
                                    return res;
                                }
                                catch (err) {
                                    console.error('[DEBUG] ERR aggregate: ', self.$path, schema.aggregate, err);
                                    // tslint:disable-next-line: no-debugger
                                    debugger;
                                    return undefined;
                                }
                            }
                            else {
                                try {
                                    return aggregateFunc_1.apply(parent, internal.calcargs);
                                }
                                catch (_a) {
                                    return undefined;
                                }
                            }
                            // return aggregateFunc()
                        }
                    };
                    internal.watch.aggregate = {
                        handler: function (newValue) {
                            // Vue.set(parent, propName, newValue);
                            if (newValue !== undefined) {
                                if (!self.$dirty && (self._options.dirtyOnBlur || self._options.dirtyOnInput)) {
                                    self.$dirty = true;
                                }
                                self.$setData(newValue, undefined, true);
                            }
                        },
                        immediate: true
                    };
                }
            }
        }
    }
    Object.defineProperty(WrappedPropertyBase.prototype, "$model", {
        /**
         * wartość prosto z modelu
         *
         * @type {*}
         * @memberof WrappedPropertyBase
         */
        get: function () {
            return this._internal.parent[this.$key];
        },
        /**
         * wartośc prosto z modelu
         *
         * @memberof WrappedPropertyBase
         */
        set: function (value) {
            if (this.$isArrayItem) {
                this._options.Vue.set(this._internal.parent, this.$key, value);
            }
            else {
                this._internal.parent[this.$key] = value;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(WrappedPropertyBase.prototype, "$value", {
        /**
         * wartośc tekstowa dla pola prostego, w polach typu `array` czy `object`, to samo co w `$model`
         *
         * @type {*}
         * @memberof WrappedPropertyBase
         */
        get: function () {
            if (this._internal.useComputedModel) {
                return this._internal.vm.model;
            }
            else {
                return this.getValue();
            }
        },
        /**
         * wartośc tekstowa dla pola prostego, w polach typu `array` czy `object`, to samo co w `$model`
         *
         * @type {*}
         * @memberof WrappedPropertyBase
         */
        set: function (newValue) {
            if (process.env.NODE_ENV === 'development') {
                // sprawdzam czy czasem nie ma calc lub aggreagate
                if (this._internal.schema.calc && !this._internal.schema.calc.when) {
                    throw new Error('ERR Próbujesz ustawić pole `' + this.$path + '` które jest wyliczane przez `calc`');
                }
                else if (this._internal.schema.aggregate) {
                    throw new Error('ERR Próbujesz ustawić pole `' + this.$path + '` które jest wyliczane przez `aggreagate`');
                }
            }
            this.setValue(newValue);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(WrappedPropertyBase.prototype, "$form", {
        /**
         * dostęp do zmiennej `form` bazowego komponentu
         *
         * @readonly
         * @type {*}
         * @memberof WrappedPropertyBase
         */
        get: function () {
            return this._internal.options.form;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(WrappedPropertyBase.prototype, "$data", {
        /**
         * obiekt danych użytkownika, można dodawać dowolne pola
         *
         * @readonly
         * @type {*}
         * @memberof WrappedPropertyBase
         */
        get: function () {
            if (this._internal.vmUserData === null) {
                /*
                if (process.env.NODE_ENV === 'development') {
                  console.log('create $data');
                }
                */
                var userData = {};
                this._internal.vmUserData = this._options.Vue.observable({ userData: userData });
            }
            return this._internal.vmUserData.userData;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(WrappedPropertyBase.prototype, "$error", {
        /**
         * komunikat błędu, lub null
         *
         * @readonly
         * @type {(string | null)}
         * @memberof WrappedPropertyBase
         */
        get: function () {
            // return this.$getUserData('error', null);
            if (!this.$disabled && this.$dirty) {
                return this.$validate();
            }
            else {
                return null;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(WrappedPropertyBase.prototype, "$warnings", {
        /**
         * lista ostrzeżeń
         *
         * @readonly
         * @type {string[]}
         * @memberof WrappedPropertyBase
         */
        get: function () {
            if (!this.$disabled && this.$dirty) {
                return this.$check();
            }
            else {
                return [];
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(WrappedPropertyBase.prototype, "$dirty", {
        /**
         * czy element był "dotykany"
         *
         * @type {boolean}
         * @memberof WrappedPropertyBase
         */
        get: function () {
            return this.$getUserData('dirty', this._options.startDirty);
        },
        /**
         * czy element był "dotykany"
         *
         * @type {boolean}
         * @memberof WrappedPropertyBase
         */
        set: function (newValue) {
            this.$setUserData('dirty', newValue);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(WrappedPropertyBase.prototype, "$path", {
        /**
         * pełna ścieżka do pola
         *
         * @readonly
         * @type {string}
         * @memberof WrappedPropertyBase
         */
        get: function () {
            var result = '';
            if (this.$parent) {
                if (this.$parent.$schema.type === 'array') {
                    return this.$parent.$path + '[' + this.$key + ']';
                }
                var ppath = this.$parent.$path;
                if (ppath) {
                    return ppath + '.' + this.$key;
                }
                else {
                    return this.$key.toString();
                }
            }
            return '';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(WrappedPropertyBase.prototype, "$hasFocus", {
        /**
         * czy pole ma fokus
         *
         * @type {boolean}
         * @memberof WrappedPropertyBase
         */
        get: function () {
            return this.$getUserData('focused', false);
            // return this._internal.reactiveData.focused;
        },
        /**
         * czy pole ma fokus
         *
         * @memberof WrappedPropertyBase
         */
        set: function (newValue) {
            if (newValue) {
                this.$setUserData('focused', true);
                // this._internal.reactiveData.focused = true;
                if (this._internal.options.resetOnFocus) {
                    this.$reset();
                }
            }
            else {
                // if (vm.focused) {
                if (true) {
                    /*
             if (typeok) {
                 this.vm.stringValue = null;
             }
             */
                    // this._internal.reactiveData.focused = false;
                    this.$setUserData('focused', false);
                    // console.log('$hasFocus', this.$path, newValue, dirty, self.dirtyOnBlur);
                    if (!this.$disabled && !this.$dirty && this._options.dirtyOnBlur) {
                        // dirty = true;
                        // console.log('validate on blur', obj.$validate());
                        // this.$validate();
                        this.$dirty = true;
                    }
                }
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(WrappedPropertyBase.prototype, "$title", {
        /**
         * pobranie tytułu pola, `title` w schema
         *
         * @readonly
         * @type {string}
         * @memberof WrappedPropertyBase
         */
        get: function () {
            return this.$schema.title ? this.$schema.title : '';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(WrappedPropertyBase.prototype, "$description", {
        /**
         * pobranie opisu pola, `description` w schema
         *
         * @readonly
         * @type {string}
         * @memberof WrappedPropertyBase
         */
        get: function () {
            return this.$schema.description ? this.$schema.description : '';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(WrappedPropertyBase.prototype, "$disabled", {
        /**
         * czy element jest wyłączony, sprawdza również obiekty nadrzędne
         *
         * @readonly
         * @type {boolean}
         * @memberof WrappedPropertyBase
         */
        get: function () {
            return functions_1.anyDisabled(this);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(WrappedPropertyBase.prototype, "$enabled", {
        /**
         * odwrotnośc $disabled
         *
         * @readonly
         * @type {boolean}
         * @memberof WrappedPropertyBase
         */
        get: function () {
            return !functions_1.anyDisabled(this);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(WrappedPropertyBase.prototype, "$isArrayItem", {
        /**
         * czy to jest element tablicy ?
         *
         * @readonly
         * @memberof WrappedPropertyBase
         */
        get: function () {
            return !!this.$parent && this.$parent.$schema.type === 'array';
        },
        enumerable: true,
        configurable: true
    });
    /**
     * ustawienie $hasFocus na tru
     *
     * @memberof WrappedPropertyBase
     */
    WrappedPropertyBase.prototype.$focus = function () {
        this.$hasFocus = true;
    };
    /**
     * ustawienie $hasFocus na false
     *
     * @memberof WrappedPropertyBase
     */
    WrappedPropertyBase.prototype.$blur = function () {
        this.$hasFocus = false;
    };
    /**
     * pobranie wartości użytkownika
     *
     * @param {string} field nazwa pola
     * @param {*} [defaultvalue] wartośc domyślna gdy pole nie istnieje
     * @returns {*}
     * @memberof WrappedPropertyBase
     */
    WrappedPropertyBase.prototype.$getUserData = function (field, defaultvalue) {
        var value = this.$data[field];
        if (value === undefined) {
            if (defaultvalue === undefined) {
                this._options.Vue.set(this._internal.vmUserData, field, null);
            }
            else {
                this._options.Vue.set(this._internal.vmUserData, field, defaultvalue);
            }
            return this._internal.vmUserData[field];
        }
        return value;
    };
    /**
     * ustawienie danych użytkownika
     *
     * @param {string} field
     * @param {*} value
     * @memberof WrappedPropertyBase
     */
    WrappedPropertyBase.prototype.$setUserData = function (field, value) {
        this._options.Vue.set(this.$data, field, value);
    };
    /**
     * niszczenie obiektu i zwalnianie zasobów
     *
     * @memberof WrappedPropertyBase
     */
    WrappedPropertyBase.prototype.$destroy = function () {
        if (this._internal.vm) {
            if (this._internal.vm.$destroy) {
                this._internal.vm.$destroy();
            }
        }
        delete this._options.disabledFields[this.$path];
    };
    /**
     * ustawianie $dirty na false
     *
     * @memberof WrappedPropertyBase
     */
    WrappedPropertyBase.prototype.$reset = function () {
        this.$dirty = false;
        // this.internal.vm.error = null;
        // this.$error = null;
    };
    /**
     * lista elementów "dotkniętych", zawiera wszystkie elementy podrżedne
     *
     * @param {IWrappedProperty[]} result
     * @returns {IWrappedProperty[]}
     * @memberof WrappedPropertyBase
     */
    WrappedPropertyBase.prototype.$dirtyList = function (result) {
        if (result === undefined) {
            result = [];
        }
        if (this.$dirty) {
            result.push(this);
        }
        return result;
    };
    /**
     * sprawdzanie ostrzeżeń
     *
     * @param {*} [value] wartość pola
     * @param {string[]} [checkResult] tablica ostrzeżeń
     * @returns {string[]} wynikowa tablica ostrzeżeń
     * @memberof WrappedPropertyBase
     */
    WrappedPropertyBase.prototype.$check = function (value, checkResult) {
        if (value === undefined) {
            value = this.$model;
        }
        if (this._internal.schema.warnings) {
            checkResult = checkResult || [];
            var funcs = getValidations_1.getValidations(this._internal.schema, this._internal.schema.warnings, true);
            for (var _i = 0, funcs_1 = funcs; _i < funcs_1.length; _i++) {
                var func = funcs_1[_i];
                var result = func(value, this.$schema.warnings);
                if (result) {
                    checkResult.push(functions_1.getWarningMessage(this._internal, result, value, this.$schema));
                    // return result;
                }
            }
            if (this._internal.vm && this._internal.vm.warningValidFunc) {
                // return this._internal.vm.validFunc;
                checkResult.push(functions_1.getWarningMessage(this._internal, this._internal.vm.warningValidFunc, value, this.$schema));
            }
            return checkResult;
        }
        return [];
    };
    /**
     * ostrzeżenie z tego pola i pól podrzędnych
     *
     * @param {IWrappedProperty[]} [result]
     * @returns {IWrappedProperty[]}
     * @memberof WrappedPropertyBase
     */
    WrappedPropertyBase.prototype.$checkAll = function (result) {
        if (result === undefined) {
            result = [];
        }
        if (this.$check().length) {
            result.push(this);
        }
        return result;
    };
    /**
     * walidacja elementu, zwraza komunikat błędu lub null
     *
     * @param {*} [value] wartość, jak nie podana to bierze z modelu
     * @returns {(string | null)}  komunikat błędu lub null
     * @memberof WrappedPropertyBase
     */
    WrappedPropertyBase.prototype.$validate = function (value) {
        // let stime = (new Date()).getTime();
        if (this.$disabled) {
            return null;
        }
        if (value === undefined) {
            value = this.$model;
        }
        var funcs = getValidations_1.getValidations(this._internal.schema, this._internal.schema, true);
        for (var _i = 0, funcs_2 = funcs; _i < funcs_2.length; _i++) {
            var func = funcs_2[_i];
            var result = func(value, this.$schema);
            if (result) {
                return functions_1.getRuleMessage(this._internal, result, value, this.$schema);
                // return result;
            }
        }
        if (this._internal.schema.validFunc) {
            if (this._internal.vm && this._internal.vm.validFunc) {
                // return this._internal.vm.validFunc;
                return functions_1.getRuleMessage(this._internal, this._internal.vm.validFunc, value, this.$schema);
            }
        }
        return null;
    };
    /**
     * waliduje element i wszystkie podrzędne
     *
     * @param {IWrappedProperty[]} [result] tymczasowa tablica lementów
     * @returns {IWrappedProperty[]} wynikowa tablica elementów które nie przeszły walidacji
     * @memberof WrappedPropertyBase
     */
    WrappedPropertyBase.prototype.$validateAll = function (result) {
        if (result === undefined) {
            result = [];
        }
        if (this.$validate()) {
            result.push(this);
        }
        return result;
    };
    /**
     * ustawienie wartości w polu
     *
     * @param {*} value nowa wartość
     * @param {string} [path] ścieżka, przydatna gdy chcemy ustawić wartośc podrzędną
     * @param {boolean} [fixArraySize] czy wymuszac zmianę wielkości tablic
     * @returns {boolean} czy udało się ustawić nową wartość
     * @memberof WrappedPropertyBase
     */
    WrappedPropertyBase.prototype.$setData = function (value, path, fixArraySize) {
        this._options.Vue.set(this._internal.parent, this.$key, value);
        return true;
        // /Vue.set(parent, propName, value);
        // return setData(this._internal.schema, this.$model, value, path, 0, this._internal.options.Vue, fixArraySize);
    };
    /**
     * pobranie danych, omija pola `computed` i inne niezgodne ze schematem
     *
     * @param {boolean} [checkDataType] czy sprawdzać typy, jeśli true to nie zwraca pól z nieprawidłowymi wartościami
     * @returns {*} wyczyszczone dane modelu
     * @memberof WrappedPropertyBase
     */
    WrappedPropertyBase.prototype.$getData = function (checkDataType) {
        return clearData_1.default(this._internal.schema, this.$model, checkDataType, this._options, this.$path);
    };
    /**
     * zdarzenie przed zmianą ścieżki
     *
     * @protected
     * @memberof WrappedPropertyBase
     */
    WrappedPropertyBase.prototype.beforePathChange = function () {
        var disabled = this.$schema.disabled;
        if (disabled) {
            delete this._options.disabledFields[this.$path];
        }
    };
    /**
     * zdarzenie po zmianie ścieżki
     *
     * @protected
     * @memberof WrappedPropertyBase
     */
    WrappedPropertyBase.prototype.afterPathChange = function () {
        var disabled = this.$schema.disabled;
        if (disabled) {
            this._options.disabledFields[this.$path] = true;
        }
    };
    /**
     * aktualizacja
     *
     * @param {*} newKey
     * @memberof WrappedPropertyBase
     */
    WrappedPropertyBase.prototype.$changeKey = function (newKey) {
        this.beforePathChange();
        this.$key = newKey;
        this._internal.mparent = this._internal.parent[newKey];
        this.afterPathChange();
    };
    Object.defineProperty(WrappedPropertyBase.prototype, "$parent2", {
        /**
         * $parent.$parent
         *
         * @readonly
         * @type {(IWrappedProperty | null)}
         * @memberof WrappedPropertyBase
         */
        get: function () {
            if (!this.$parent) {
                return null;
            }
            return this.$parent.$parent;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(WrappedPropertyBase.prototype, "$parent3", {
        /**
         * $parent.$parent.$parent
         *
         * @readonly
         * @type {(IWrappedProperty | null)}
         * @memberof WrappedPropertyBase
         */
        get: function () {
            if (!this.$parent2) {
                return null;
            }
            return this.$parent2.$parent;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * usuwanie bierzącego wiersza z tablicy
     *
     * @param {number} [index]
     * @returns {boolean}
     * @memberof WrappedPropertyBase
     */
    WrappedPropertyBase.prototype.$removeRow = function (index) {
        if (this.$isArrayItem) {
            return this.$parent.$removeRow(this.$key);
        }
        return false;
    };
    /**
     * przesuwanie bieżącego wiersza tablicy w górę
     *
     * @param {number} [index]
     * @returns {boolean}
     * @memberof WrappedPropertyBase
     */
    WrappedPropertyBase.prototype.$moveUp = function (index) {
        if (this.$isArrayItem) {
            return this.$parent.$moveUp(this.$key);
        }
        return false;
    };
    /**
     * przesuwanie bieżącego wiersza tablicy w dół
     *
     * @param {number} [index]
     * @returns {boolean}
     * @memberof WrappedPropertyBase
     */
    WrappedPropertyBase.prototype.$moveDown = function (index) {
        if (this.$isArrayItem) {
            return this.$parent.$moveDown(this.$key);
        }
        return false;
    };
    /**
     * czyszczenie bieżącego wiersza tablicy, nadawanie wartości domyślnych
     *
     * @param {number} [index]
     * @returns {boolean}
     * @memberof WrappedPropertyBase
     */
    WrappedPropertyBase.prototype.$clearRow = function (index) {
        if (this.$isArrayItem) {
            return this.$parent.$clearRow(this.$key);
        }
        return false;
    };
    /**
     * naprawianie formatu daty
     *
     * @returns {number}
     * @memberof WrappedPropertyBase
     */
    WrappedPropertyBase.prototype.$fixDateFormat = function () {
        return 0;
    };
    /**
     * pobranie wartości z modelu
     *
     * @protected
     * @returns {*}
     * @memberof WrappedPropertyBase
     */
    WrappedPropertyBase.prototype.getValue = function () {
        return this.$model;
    };
    /**
     * ustawienie wartości na modelu
     *
     * @protected
     * @param {*} newValue
     * @memberof WrappedPropertyBase
     */
    WrappedPropertyBase.prototype.setValue = function (newValue) {
        if (!this.$schema.$disabled && !this.$dirty && this._internal.options.dirtyOnInput) {
            this.$dirty = true;
        }
        this.$model = newValue;
    };
    return WrappedPropertyBase;
}());
exports.default = WrappedPropertyBase;
//# sourceMappingURL=WrappedPropertyBase.js.map